<script lang="ts">
  import { t } from '../lib/i18n.js';
  let { onBack } = $props<{ onBack: () => void }>();
</script>

<div class="card not-found">
  <div class="not-found-content">
    <div class="not-found-icon">404</div>
    <h2>{$t('notfound.title')}</h2>
    <p class="dim">{$t('notfound.body')}</p>
    <button onclick={onBack} class="primary">{$t('notfound.back')}</button>
  </div>
</div>

<style>
  .not-found {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 300px;
  }

  .not-found-content {
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
  }

  .not-found-icon {
    font-size: 64px;
    font-weight: 700;
    background: linear-gradient(135deg, var(--accent) 0%, #8e7cff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    letter-spacing: 0.02em;
  }

  h2 {
    margin: 0;
    font-size: 20px;
    color: var(--text);
  }

  p {
    margin: 0;
    max-width: 280px;
    line-height: 1.5;
  }

  button {
    margin-top: 8px;
  }
</style>
